export default __webpack_public_path__ + "static/gopi-7aaf5473810a71d8f0def10857999b1c.svg";